module.exports = __webpack_public_path__ + "img/Monte_Kope_1.c826b790.jpg";